/**
 * Testimonials from PH Therapy clients (pandhtherapy.co.uk)
 */

export interface TestimonialData {
  quote: string;
  author: string;
  age?: number;
}

export const testimonials: TestimonialData[] = [
  {
    quote: "This is a perfect programme for me. As a non-sporty woman, I never imagined I'd be lifting weights at sixty! It's definitely keeping the years at bay.",
    author: "Karen",
    age: 59
  },
  {
    quote: "Tové has made me feel safe and supported in my journey back to exercise after surgery. I really appreciated the way you kept checking in with me between our sessions, and you helped me to feel so much more confident about what my body could do.",
    author: "Katie",
    age: 43
  },
  {
    quote: "As I am undergoing prostate cancer treatment, I wasn't sure I would be able to go on a skiing trip with my son. Through regular resistance training I was able to do some of the best skiing I have ever done. I felt strong, in control and managed to enjoy the trip without any excessive muscle stiffness or injuries.",
    author: "David",
    age: 83
  },
  {
    quote: "Training with & supervision by P&H Therapy has resulted in me feeling the best I have in 20 years. Renewed energy, engagement and focus.",
    author: "Greg",
    age: 60
  },
  {
    quote: "I started training with PH Therapy in 2020 and they have significantly helped me improve and change the way I feel about nutrition and use of precisely done exercises to build my muscle strength, agility and flexibility. PH Therapy provided education and guidance with every step of the way. The structure was clear, logical and effective. My weight is down by 15kg, my 5-aside football performance has improved and I feel 20 years younger. Thank you to Ben and all at PH Therapy.",
    author: "Mark",
    age: 59
  },
  {
    quote: "Tové started supporting me after I had an ACL tear and reoccurring irritation throughout my rehab after surgery. She's been a friendly, knowledgeable, and patient person throughout - consistently checking in and slowly introducing in new exercises to test my range of motion and muscle growth. She's been incredibly thorough and has answered loads of my questions about physio, rehab, and nutrition.",
    author: "Mira",
    age: 29
  },
  {
    quote: "This service is like Fortnum & Mason.",
    author: "Cathy",
    age: 66
  },
  {
    quote: "I trusted the doctors and nurses I was a fairly passive participant in all of this. A friend suggested Ben might be able to help due to his work with cancer rehabilitation patients. When Ben arrived I was immediately impressed with his positivity and knowledge. I'm not a negative person, but occasionally I would lose motivation, and without even knowing he would turn me around with his positivity and encouragement. My hero Benjamin Duckett. Hopefully, you never need his help but if you do, don't hesitate to call him. He is worth his weight in gold.",
    author: "Maurice",
    age: 66
  },
  {
    quote: "Following two major surgeries and a course of radiotherapy, I had lost my fitness and was apprehensive about restarting exercise. PH Therapy have helped me to regain my motivation and feel confident with resistance training. I look forward to my weekly sessions with Tové and feel that I am progressing well under her expert guidance. I am fitter and healthier now than I have been at any time since my surgery. Thank you!",
    author: "Steve",
    age: 71
  },
  {
    quote: "I was introduced to Ben through a mutual friend. I am now a convert and have signed up for my next course of 26 sessions. I am impressed, not only with Ben's supportive personality but with his ability to transfer his professional skill online. I feel as if we meet in person each session. I have left every training session better than when I started. I enjoy training with Ben and would highly recommend him.",
    author: "Cathy",
    age: 66
  },
  {
    quote: "At 22 years old, I had started to come to terms that my body just didn't quite work the same way... until I began my course with PH Therapy in mid-2020. Ben was honest and told me that he hadn't treated hypermobility before. However, by the time our sessions kicked off, it became apparent that Ben had put himself through an intensive crash course to learn just about everything there was to know. PH Therapy has transformed the way that I go about everyday life. They have provided me with the launchpad from which I can continue to improve and strengthen my body.",
    author: "Louis",
    age: 23
  },
  {
    quote: "I have been seeing Kayla for a few months now and am more than pleased with our recently assessed results. Whilst actual weight loss has indeed occurred, I am delighted with the reduction from the stomach, hips and surrounding areas. She is most encouraging and even pushes me, in order to obtain our combined goals.",
    author: "Andrew",
    age: 68
  },
  {
    quote: "I first met Ben when I was recovering from aggressive chemotherapy and surgery for cancer removal. My oncologist recommended him. I was very sceptical - I am the antithesis of a gym bunny - but the impact was pretty immediate. Ben has an excellent approach and is persuasive without being aggressive. Long after my full recovery from cancer I still exercise twice weekly with Ben. I thoroughly recommend him.",
    author: "Nick",
    age: 58
  },
  {
    quote: "After breaking my humerus with a fall, Kayla came twice weekly to do specific and adapted exercises to restore my arm. Moreover, Kayla now comes to my home in order to maintain my general health. Kayla is professional, punctual, polite and very good-natured with a good sense of humour. I couldn't recommend her more.",
    author: "Isabelle",
    age: 80
  },
  {
    quote: "Ben Duckett, Joe Othen-Price and Tové work together as Exercise Physiologists. They have helped me keep mobile since last year. They come to our house twice a week to deliver exercise and discuss my situation generally. They are both sympathetic, kind and thoughtful with a good knowledge of the best way to keep as well as possible. I can highly recommend them.",
    author: "Carolyn",
    age: 78
  },
  {
    quote: "Ben is fantastic to work with and so enthusiastic about helping his clients realign. He has turned a desk-bound physically compromised lawyer into someone who is now stronger healthier and embracing the challenges. Thanks, Ben … Onwards!",
    author: "Elaine",
    age: 61
  },
  {
    quote: "Every senior executive is faced with the challenge of staying healthy while managing stressful positions. By April 2021, aggravated by the COVID-19 pandemic, I had gained weight, high blood pressure, and high cholesterol. My GP referred me to Ben. It's three years later and I feel blessed. Ben has transformed my approach and understanding of training for wellness. My blood pressure is better controlled, my body mass and body composition have improved. He is a joy to work with. I would highly recommend anyone to start working with Ben and his team. Thank you!",
    author: "Marco",
    age: 57
  },
  {
    quote: "Ben has been invaluable in helping me recover from injury and getting me back to full movement and training in a safe and timely manner. His expertise shines through and the whole service is flawless.",
    author: "Katie",
    age: 44
  },
  {
    quote: "The classes were straightforward and could be done in your front room. The follow-up summary of the exercises was really useful. The programme wasn't daunting and was adapted for various levels of fitness and ability. Ben took the time to explain why we were doing specific exercises and the theory behind them which was incredibly helpful. I'd definitely recommend him to others. Easy to follow, great clear instructions. Good for all abilities!",
    author: "Taylor Wessing employees",
  }
];
